export enum UserStatus {
  Pending = "PENDING",
  Active = "ACTIVE",
  PasswordReset = "PASSWORD_RESET",
  PasswordExpired = "PASSWORD_EXPIRED",
  LockedOut = "LOCKED_OUT",
  Deactivated = "DEACTIVATED",
  NotInIDP = "NOT_IN_IDP",
  Unknown = "UNKNOWN",
}

export enum TenantType {
  HA = "HA",
  Sponsor = "SPONSOR",
  Accumulus = "ACCUMULUS",
}

export enum UserType {
  External = "EXTERNAL",
  Internal = "INTERNAL",
}

export enum Role {
  // systemRoles
  AccumulusAdmin = "ACC_ADMIN",
  OrganizationAdmin = "ORG_ADMIN",
  ProgramAdmin = "PROGRAM_ADMINISTRATOR",
  StandardUser = "STANDARD_USER",
  ExternalUser = "EXTERNAL_USER",

  // projectRoles
  ProjectManager = "PROJECT_MANAGER",
  ContentEditor = "CONTENT_EDITOR",
  ContentViewer = "CONTENT_VIEWER",
  ExpertReviewer = "EXPERT_REVIEWER",
}

// ToDo (AV): Doing this on the FE may not be necessary in future. We will have to revisit this.
export const ROLES_PRIORITIES = {
  [Role.AccumulusAdmin]: 0,
  [Role.OrganizationAdmin]: 1,
  [Role.ProgramAdmin]: 2,
  [Role.StandardUser]: 3,
  [Role.ExternalUser]: 4,
  [Role.ProjectManager]: 5,
  [Role.ContentEditor]: 6,
  [Role.ContentViewer]: 7,
  [Role.ExpertReviewer]: 8,
};

export enum EmailNotificationPreference {
  DailyDigest = "dailyDigest",
  NewProjectAccess = "newProjectAccess",
  ExternalUserActivatedAccount = "externalUserActivatedAccount",
  ProjectAccessAndInvitations = "projectAccessAndInvitations",
  OptOut = "optOut",
}

export enum EmailGroupNotificationPreference {
  DailyDigest = "dailyDigest",
  ProjectAccessAndInvitations = "projectAccessAndInvitations",
  ContentAndQuestions = "contentAndQuestions",
  TaskManagement = "taskManagement",
  Milestones = "milestones",
  AllOff = "allOff",
}
